module.exports = __webpack_public_path__ + "fonts/OpenSansCondensed-Light.3589bddb.ttf";